// import external dependencies
import 'jquery';
import 'focus-visible';

// Import everything from autoload
//;

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import vehicles from './routes/vehicles';
import publications from './routes/publications';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Vehicles
    vehicles,
    // Publications
    publications,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js